module.exports = __webpack_public_path__ + "img/charade-false-icon.7fd0b672.svg";